"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class AssetIdentification extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'assetIdentification';
        this._assetId = initParams.asset_id;
    }
    set assetId(value) {
        console.error('Do not set objects this way');
    }
    get assetId() {
        return this._assetId;
    }
}
exports.default = AssetIdentification;
//# sourceMappingURL=assetIdentification.js.map